<!--************************Breadcrumbs div***********************************-->
<div class="breadcrumb_outer_box" style="background-color: #dedede;line-height: 0px;">
  <ol class="breadcrumb" style="background: transparent;
                  font-size: 12px;margin-bottom: 0 !important;">
    <li class="breadcrumb-item" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ol>
</div>
<mat-toolbar>
  <h6 class="show-title">{{pageTitle}}</h6>
  <button *ngIf="showSave" class="more-btn-custom" mat-raised-button (click)="addDevice()">
    <i class="material-icons icon-layout-custom">add_circle</i><span class="m_l_5 mob_hide">Add New</span>
  </button>
</mat-toolbar>
<div fxLayoutAlign="center center" fxLayout="column" style="padding: 16px; margin-bottom: 100px;">
  <form [formGroup]="uForm" (ngSubmit)="saveDevice()" class="form_outer_box">
    <div class="form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput  placeholder="Device Type" type="text" matInput formControlName="device_type" id="device_type">
        <!-- <mat-placeholder class="placeholder">Device type &nbsp;*</mat-placeholder> -->
      </mat-form-field>
    </div>
    <div class="form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput  placeholder="Device Detail" type="text" matInput formControlName="device_detail" id="device_detail">
        <!-- <mat-placeholder class="placeholder">Device Detail &nbsp;*</mat-placeholder> -->
      </mat-form-field>
    </div>
    <div class="btn-box text-center m_t_0" *ngIf="showSave">
      <button mat-raised-button style="border-radius: 50px;" type="submit" [disabled]="!uForm.valid">Save</button>
    </div>
    <div class="btn-box text-center m_t_0" *ngIf="showUpdate">
      <button mat-raised-button style="border-radius: 50px;" (click)="saveDevice()" type="button"
        [disabled]="!uForm.valid">Update</button>
    </div>
  </form>
</div>